module.exports = __webpack_public_path__ + "static/media/me.464a1fe1.png";